import { createStore, compose, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import promiseMiddleware from 'redux-promise-middleware';
import reducers from './reducers';


export default function configureStore(initialState: Object) {
  const isProd: boolean = process.env.NODE_ENV === 'production';

  const middlewares: Array<any> = [
    thunk,
    promiseMiddleware(),
  ];

  let enhancers;

  if (!isProd && process.env.STATSRADIO_APP_ENABLE_REDUX_LOGGER === 'true') {
    const logger = createLogger();

    const middlewareDev: Array<any> = [logger];

    enhancers = compose(
      applyMiddleware(...middlewares, ...middlewareDev),
      window.devToolsExtension ? window.devToolsExtension() : f => f,
    );
  } else {
    enhancers = compose(applyMiddleware(...middlewares));
  }

  const store = createStore(
    reducers,
    enhancers,
  );

  return store;
}



// WEBPACK FOOTER //
// ./src/statsradio/redux/configureStore.js